import { Component, Inject, type OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { type ColDef } from 'ag-grid-community'
import { DefaultGridContextMenu } from 'src/app/05_ag-grid-configs/02_global-settings/grid-options'

@Component({
  standalone: false,
  selector: 'app-kpi-detail-modal',
  templateUrl: './kpi-detail-modal.component.html',
  styleUrls: ['./kpi-detail-modal.component.scss']
})
export class KpiDetailModalComponent implements OnInit {
  closeModal!: () => void
  title: string = ''
  description: string = ''
  kpiNote: string = ''
  chartData: any = {}
  chartOptions: any = {}

  // ag-Grid properties
  columnDefs: ColDef[] = []
  rowData: any[] = []
  gridOptions = {
    defaultColDef: {
      sortable: true,
      filter: true,
      resizable: true
    },
    domLayout: 'autoHeight',
    suppressHorizontalScroll: true,
    getContextMenuItems: params => DefaultGridContextMenu(params)
  }

  constructor (public dialogRef: MatDialogRef<KpiDetailModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit () {
    this.initializeKPIData(this.data.kpiType, this.data.row_data)
    console.log('KPI Detail Modal Data:', this.data)
  }

  initializeKPIData (kpiType: string, row_data: any) {
    // const baseSeasons = ['FW24', 'SS25', 'FW25', 'SS26', 'FW26']
    this.rowData = row_data
    const baseSeasons = row_data.map(item => item.season)
    const baseValues = row_data.map(item => parseInt(item.value, 10))

    // Common column definitions
    this.columnDefs = [
      { headerName: 'Season', field: 'season', width: 120 },
      { headerName: 'Value', field: 'value', width: 120 },
      { headerName: 'Δ vs Prior (pp)', field: 'delta', width: 160 }
    ]

    switch (kpiType) {
      case 'inventoryEfficiency':
        this.title = 'Inventory Efficiency — Details'
        this.description = 'Season-over-season Inventory Efficiency (higher is better).'
        this.kpiNote = 'Normalized blend of lost-sales reduction and overstock avoidance vs baseline.'
        // Mock data for inventoryEfficiency chart
        this.chartData = {
          labels: baseSeasons,
          datasets: [
            {
              label: 'Inventory Efficiency',
              data: baseValues,
              borderColor: '#1d63a5',
              fill: false
            }
          ]
        }

        break

      case 'regPriceSellThrough':
        this.title = 'Reg Price Sell-Through Improvement — Details'
        this.description = 'Season-over-season regular-price sell-through improvement vs baseline.'
        this.kpiNote = 'Highlights uplift from sizing, allocation, and profile accuracy improvements.'
        // Mock data for regPriceSellThrough chart
        this.chartData = {
          labels: baseSeasons,
          datasets: [{ label: 'Sell-Through %', data: baseValues, borderColor: '#1d63a5', fill: false }]
        }

        break

      case 'profilePrecision':
        this.title = 'Profile Precision Index — Details'
        this.description = 'Profile accuracy across seasons.'
        this.kpiNote = 'For size-level precision vs demand, select Subclass + Size Range.'
        // Mock data for profilePrecision chart
        this.chartData = {
          labels: baseSeasons,
          datasets: [{ label: 'Profile Precision', data: baseValues, borderColor: '#1d63a5', fill: false }]
        }
        break

      case 'packAlignment':
        this.title = 'Pack Alignment Index — Details'
        this.description = 'Season-over-season pack mismatch % (lower is better).'
        this.kpiNote = 'Volume-weighted across optimization jobs per season.'
        // Mock data for packAlignment chart
        this.chartData = {
          labels: baseSeasons,
          datasets: [{ label: 'Pack Mismatch %', data: baseValues, borderColor: '#1d63a5', fill: false }]
        }
        break

      case 'profileAcceptance':
        this.title = 'Profile Acceptance Rate - Details'
        this.description = 'Season-over-season % of profiles approved without edits.'
        this.kpiNote = 'Indicates planner trust and workflow adoption.'
        // Mock data for profileAcceptance chart
        this.chartData = {
          labels: baseSeasons,
          datasets: [
            {
              label: 'Profile Acceptance',
              data: baseValues,
              borderColor: '#1d63a5',
              fill: false
            }
          ]
        }
        break
    }

    this.chartOptions = {
      responsive: true,
      plugins: {
        legend: { display: false },
        tooltip: {
          callbacks: {
            label: (context: any) =>
                            `${context.dataset.label}: ${context.raw}${kpiType === 'packAlignment' ? '%' : '%'}`
          }
        }
      },
      scales: {
        y: {
          beginAtZero: true,
          max: kpiType === 'packAlignment' ? 20 : 100,
          ticks: {
            callback: (value: number) => value + '%'
          }
        }
      }
    }
  }

  onClose (): void {
    if (this.closeModal) {
      this.closeModal()
    } else {
      this.dialogRef.close()
    }
  }
}
